<template>
  <div ref="formContainer">
    <user-log-table :users="users" :totalPages="totalPages" :page="page" @setPage="setPage" :setSkeletonLoader="displayLoader"></user-log-table>
  </div>
</template>

<script>
  import helpers from "@/helpers.js";
  import UserLogTable from "./user_log_table";
  import VueSkeletonLoader from 'skeleton-loader-vue';
  export default {
    components: {
      UserLogTable,VueSkeletonLoader
    },

    data: function () {
      return {
        page: 0,
        fullPage: "",
        displayLoader: true,
      };
    },

    computed: {
      users: function () {
        return this.$store.getters["users/users"];
      },
      totalPages: function () {
        return this.$store.getters["users/totalPages"];
      },
    },

    created: function () {
      this.page = helpers.getPageQuery();
    },

    watch: {
      page: function (val) {
        // let loader = this.$loading.show({
        //   loader: "dots",
        //   container: this.fullPage ? null : this.$refs.formContainer,
        // });
        this.setSkeletonLoader(true);
        this.$store.dispatch("users/getAllUsersLog", val).then(() => {
          // loader.hide();
          setTimeout(() => {
          // loader.hide();
            this.setskeletonLoader(false);
          }, 1000);
        });
      },
    },

    methods: {
      setPage(page) {
        this.page = page;
        this.$router.push("log?page=" + page);
      },
      setSkeletonLoader(val){
        this.displayLoader = val;
      },
    },
  };
</script>
<style>
  .custom {
    position: absolute;
    z-index: 999;
    top: 246px;
    left: 40%;
    opacity: 0.5;
  }
</style>